import {
  FaPhone,
  FaEnvelope,
  FaClock,
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
  FaWhatsapp,
  FaUserMd,
  FaProcedures,
  FaClinicMedical,
  FaTiktok,
  FaPlus,
} from "react-icons/fa";
import { SiTripadvisor } from "react-icons/si";
import { MdHealthAndSafety, MdOutlineLocalPostOffice } from "react-icons/md";
import { GiHerbsBundle } from "react-icons/gi";
import { Link } from "react-router-dom";
import { BiPhoneCall } from "react-icons/bi";
import { LuMapPin } from "react-icons/lu";
import ichgreenlogo from "../../assets/images/IchName/logoICH.svg"

const Footerbar = () => {
  const currentYear = new Date().getFullYear();

  const clickScroller = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const services = [
    {
      name: "Channeling Services from Over 1,000 Doctors",
      icon: <FaUserMd className="mr-2 text-yellow-400" />,
    },
    {
      name: "Convenient Ayurvedic Medications",
      icon: <GiHerbsBundle className="mr-2 text-yellow-400" />,
    },
    {
      name: "Standard Ayurvedic Treatments",
      icon: <FaProcedures className="mr-2 text-yellow-400" />,
    },
    {
      name: "Residential Ward Facilities",
      icon: <FaClinicMedical className="mr-2 text-yellow-400" />,
    },
    {
      name: "Aftercare",
      icon: <MdHealthAndSafety className="mr-2 text-yellow-400" />,
    },
    {
      name: "Preventive Care",
      icon: <MdHealthAndSafety className="mr-2 text-yellow-400" />,
    },
  ];

  interface MenuNames {
    id: number;
    name: string;
    url: string;
  }

  const menuNames: MenuNames[] = [
    {
      id: 1,
      name: "Home",
      url: "/",
    },
    {
      id: 2,
      name: "Service",
      url: "/service",
    },
    {
      id: 3,
      name: "About Us",
      url: "/about-us",
    },
    {
      id: 4,
      name: "Gallery",
      url: "/gallery",
    },
    {
      id: 5,
      name: "Contact",
      url: "/contact-us",
    },
  ];

  return (
    <footer className="bg-gradient-to-b from-green-500 to-green-900 text-white">
      {/* Main Footer Content */}
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Hospital Branding */}
          <div className="space-y-6">
            <div className="flex items-center">
              <div className="bg-white px-6 py-2 rounded-lg shadow-md inline-block">
                <img src={ichgreenlogo} alt="CeylonHospiytal"  width={200} height={200}/>
                {/* <p className="font-bold text-4xl text-green-700 text-center Blinker-Bold tracking-tight">
                  Ceylon Hospital
                </p> */}
                <div className="h-1 bg-gradient-to-r from-green-500 to-blue-500 mt-2 rounded-full"></div>
              </div>
            </div>
            <p className="text-white leading-tight Blinker-Regular">
              Ceylon Hospital offers world-class healthcare with advanced
              treatments and a team of highly qualified professionals.
              <br />
              <br /> We are committed to providing exceptional care, focusing on
              restoring your health with expertise, compassion, and precision.
            </p>

            {/* <div className="flex space-x-4 pt-2">
              <a
                href="https://wa.me/94705509898"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-green-700 hover:bg-green-600 p-3 rounded-full transition"
              >
                <FaWhatsapp className="text-lg" />
              </a>
              <a
                href="tel:+94712509898"
                className="bg-green-700 hover:bg-green-600 p-3 rounded-full transition"
              >
                <FaPhone className="text-lg" />
              </a>
              <a
                href="mailto:info@ceylonhospital.com"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-green-700 hover:bg-green-600 p-3 rounded-full transition"
              >
                <FaEnvelope className="text-lg" />
              </a>
            </div> */}

            <div className="flex space-x-4 pt-2">
              {/* WhatsApp */}
              <a
                href="https://wa.me/94705509898"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#25D366] hover:bg-[#128C7E] p-3 rounded-full transition-colors flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-green-600 focus:ring-offset-2"
                aria-label="Chat with us on WhatsApp (opens in new tab)"
              >
                <span className="sr-only">WhatsApp</span>
                <FaWhatsapp className="text-xl text-white" />
              </a>

              {/* Phone */}
              <a
                href="tel:+94712509898"
                className="bg-green-700 hover:bg-green-800 p-3 rounded-full transition-colors flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-green-700 focus:ring-offset-2"
                aria-label="Call us at +94 71 250 9898"
              >
                <span className="sr-only">Phone</span>
                <FaPhone className="text-xl text-white" />
              </a>

              {/* Email */}
              <a
                href="mailto:info@ceylonhospital.com?subject=Website%20Enquiry"
                className="bg-red-600 hover:bg-red-700 p-3 rounded-full transition-colors flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-red-600 focus:ring-offset-2"
                aria-label="Email us at info@ceylonhospital.com"
              >
                <span className="sr-only">Email</span>
                <FaEnvelope className="text-xl text-white" />
              </a>
            </div>
          </div>

          {/* Treatments */}
          <div>
            <h1 className="text-2xl Blinker-SemiBold mb-6 pb-2 border-b border-yellow-400 flex items-center">
              {/* <MdHealthAndSafety className="mr-2 text-yellow-400" /> */}
              Our Services
            </h1>
            <ul className="space-y-3 Blinker-Regular">
              {services.map((treatment, index) => (
                <li key={index} className="flex items-center">
                  {treatment.icon}
                  <p>{treatment.name}</p>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h1 className="text-2xl Blinker-SemiBold mb-6 pb-2 border-b border-yellow-400">
              Quick Links
            </h1>

            <ul className="space-y-3 list-none">
              {menuNames.map((link, index) => (
                <li key={index} className="group relative">
                  <Link
                    to={link.url}
                    onClick={clickScroller}
                    className="hover:text-yellow-300 hover:font-bold transition Blinker-Regular flex items-center gap-2"
                  >
                    <span>
                      {" "}
                      <FaPlus />
                    </span>
                    <span>{link.name}</span>
                  </Link>
                </li>
              ))}
            </ul>

            {/* <ul className="space-y-3">
              {menuNames.map((link, index) => (
                <div
                  key={index}
                  className="hover:text-yellow-300 hover:Blinker-Bold transition Blinker-Regular"
                >
                  <Link
                    to={link.url}
                    onClick={clickScroller}
                    className="flex items-center gap-2"
                  >
                    <span>
                      <FaPlus />
                    </span>
                    <span>{link.name}</span>
                  </Link>
                </div>
              ))}
            </ul> */}
          </div>

          {/* Contact & Hours */}
          <div>
            <h1 className="text-2xl Blinker-SemiBold mb-6 pb-2 border-b border-yellow-400">
              Contact Info
            </h1>
            <div className="space-y-4 Blinker-Regular">
              <div className="flex flex-col gap-3">
                <div className="flex flex-row gap-5 items-center">
                  <div className="text-4xl">
                    <LuMapPin />
                  </div>
                  <div className="flex flex-col">
                    <p className="leading-tight">
                      No.228/1, Asiri Mawatha, Kandy Road, Yakkala, Gampaha, Sri
                      Lanka.
                    </p>
                  </div>
                </div>
                <div className="flex flex-row gap-5 items-center">
                  <div className="text-4xl">
                    <BiPhoneCall />
                  </div>
                  <div className="flex flex-col leading-tight">
                    <div className="flex flex-row gap-3">
                      <p>Contact Us 24/7</p>
                      <p className="Blinker-SemiBold">+94 71 250 9898</p>
                    </div>
                    <div className="flex flex-row gap-3">
                      <p>WhatsApp 24/7</p>
                      <p className="Blinker-SemiBold">+94 70 550 9898</p>
                    </div>
                  </div>
                </div>
                <div className="flex flex-row gap-5 items-center">
                  <div className="text-4xl">
                    <MdOutlineLocalPostOffice />
                  </div>
                  <div className="flex flex-col leading-tight">
                    <p>Do you have a Question?</p>
                    <p className="Blinker-SemiBold">info@ceylonhospital.com</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6 border-t border-green-700 pt-10">
          <div className="flex flex-col items-center">
            <div className="bg-white text-green-800 p-3 rounded-full mb-2">
              <MdHealthAndSafety className="text-3xl" />
            </div>
            <p className="text-center  Blinker-Regular">
              ISO Certified Facility
            </p>
          </div>
          <div className="flex flex-col items-center">
            <div className="bg-white text-green-800 p-3 rounded-full mb-2">
              <GiHerbsBundle className="text-3xl" />
            </div>
            <p className="text-center  Blinker-Regular">Authentic Ayurveda</p>
          </div>
          <div className="flex flex-col items-center">
            <div className="bg-white text-green-800 p-3 rounded-full mb-2">
              <FaClock className="text-3xl" />
            </div>
            <p className="text-center  Blinker-Regular">6 Years of Service</p>
          </div>
          <div className="flex flex-col items-center">
            <div className="bg-white text-green-800 p-3 rounded-full mb-2">
              <SiTripadvisor className="text-3xl" />
            </div>
            <p className="text-center  Blinker-Regular">
              TripAdvisor Excellence
            </p>
          </div>
        </div>
      </div>

      {/* Social & Copyright */}
      <div className="bg-green-950 py-6">
        <div className="container mx-auto px-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            {/* <div className="flex space-x-5 mb-4 md:mb-0">
              <a
                href="https://www.facebook.com/CeylonHospital"
                target="_blank"
                className="bg-green-800 hover:bg-yellow-500 hover:text-green-900 p-2 rounded-full transition"
              >
                <FaFacebookF />
              </a>
              <a
                href="https://www.instagram.com/ceylonhospital"
                target="_blank"
                className="bg-green-800 hover:bg-yellow-500 hover:text-green-900 p-2 rounded-full transition"
              >
                <FaInstagram />
              </a>
              <a
                href="https://www.tiktok.com/@ceylonhospital"
                target="_blank"
                className="bg-green-800 hover:bg-yellow-500 hover:text-green-900 p-2 rounded-full transition"
              >
                <FaTiktok />
              </a>
              <a
                href="https://www.linkedin.com/company/ceylon-hospital"
                target="_blank"
                className="bg-green-800 hover:bg-yellow-500 hover:text-green-900 p-2 rounded-full transition"
              >
                <FaLinkedinIn />
              </a>
              <a
                href="https://www.youtube.com/@ceylonhospital"
                target="_blank"
                className="bg-green-800 hover:bg-yellow-500 hover:text-green-900 p-2 rounded-full transition"
              >
                <FaYoutube />
              </a>
            </div> */}
            <div className="flex space-x-4 mb-4 md:mb-0">
              {/* Facebook */}
              <a
                href="https://www.facebook.com/CeylonHospital"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-green-800 hover:bg-yellow-500 hover:text-green-900 p-3 rounded-full transition-colors flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2"
                aria-label="Visit our Facebook page (opens in new tab)"
              >
                <span className="sr-only">Facebook</span>
                <FaFacebookF className="w-5 h-5 text-white hover:text-green-900" />
              </a>

              {/* Instagram */}
              <a
                href="https://www.instagram.com/ceylonhospital"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-green-800 hover:bg-yellow-500 hover:text-green-900 p-3 rounded-full transition-colors flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2"
                aria-label="Visit our Instagram profile (opens in new tab)"
              >
                <span className="sr-only">Instagram</span>
                <FaInstagram className="w-5 h-5 text-white hover:text-green-900" />
              </a>

              {/* TikTok */}
              <a
                href="https://www.tiktok.com/@ceylonhospital"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-green-800 hover:bg-yellow-500 hover:text-green-900 p-3 rounded-full transition-colors flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2"
                aria-label="Visit our TikTok profile (opens in new tab)"
              >
                <span className="sr-only">TikTok</span>
                <FaTiktok className="w-5 h-5 text-white hover:text-green-900" />
              </a>

              {/* LinkedIn */}
              <a
                href="https://www.linkedin.com/company/ceylon-hospital"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-green-800 hover:bg-yellow-500 hover:text-green-900 p-3 rounded-full transition-colors flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2"
                aria-label="Visit our LinkedIn page (opens in new tab)"
              >
                <span className="sr-only">LinkedIn</span>
                <FaLinkedinIn className="w-5 h-5 text-white hover:text-green-900" />
              </a>

              {/* YouTube */}
              <a
                href="https://www.youtube.com/@ceylonhospital"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-green-800 hover:bg-yellow-500 hover:text-green-900 p-3 rounded-full transition-colors flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2"
                aria-label="Visit our YouTube channel (opens in new tab)"
              >
                <span className="sr-only">YouTube</span>
                <FaYoutube className="w-5 h-5 text-white hover:text-green-900" />
              </a>
            </div>

            <p className="text-green-300 text-sm text-center  Blinker-Regular">
              Copyright © {currentYear}{" "}
              <span className=" Blinker-SemiBold">ALMG IT </span> All Right
              Reserved. |
              <Link
                onClick={clickScroller}
                to="https://policies.ceylonhospital.com/"
                className="hover:text-yellow-400  ml-2"
              >
                Privacy Policy
              </Link>{" "}
              |
              <Link
                onClick={clickScroller}
                to="https://terms.ceylonhospital.com/"
                className="hover:text-yellow-400 ml-2"
              >
                Terms and Conditions
              </Link>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footerbar;
